import { render } from "./ForgetPasswordCard.vue?vue&type=template&id=409043e9"
import script from "./ForgetPasswordCard.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__